import { Injectable, signal } from '@angular/core';
import { addProxyRule } from '@arcgis/core/core/urlUtils.js';
import { LayerEntity } from '@gishub/domain';

@Injectable({ providedIn: 'root' })
export class ArcgisDomainService {
  private readonly _domains = signal<string[]>([
    'arcgis.com',
    'arcgisonline.com',
  ]);

  readonly domains = this._domains.asReadonly();

  addDomainsFromLayers(layers: LayerEntity[], proxyUrl?: string): void {
    const cleanProxyUrl = proxyUrl
      ? proxyUrl.replace(/\?.*$/, '').replace(/\/+$/, '')
      : undefined;

    const walk = (items: LayerEntity[]) => {
      for (const item of items) {
        if (item.url) {
          try {
            const { hostname } = new URL(item.url);
            if (!this._domains().includes(hostname)) {
              this._domains.update(d => [...d, hostname]);
            }
            if (cleanProxyUrl && item.hasProxy) {
              addProxyRule({ urlPrefix: hostname, proxyUrl: cleanProxyUrl });
            }
          } catch {
            /* skip invalid urls */
          }
        }
        if (item.layers?.length) {
          walk(item.layers);
        }
      }
    };

    walk(layers);
  }

  isArcgisRequest(url: string): boolean {
    return this._domains().some(domain => url.includes(domain));
  }

  isExternalCorsError(url: string, status: number): boolean {
    if (status !== 0) return false;
    try {
      const hostname = new URL(url).hostname;
      return this._domains().some(domain => hostname.includes(domain));
    } catch {
      return false;
    }
  }
}
